<template>
  <nav class="menu">
    <ul>
      <template v-for="route in routes">
        <template v-if="!route.hidden">
          <menu-item
            :key="route.meta.exactPath"
            :path="route.meta.exactPath"
            :title="route.meta.title"
            :isExternal="route.meta.isExternal"
            :hasSubLinks="
              route.meta.hasSubLinks != null ? route.meta.hasSubLinks : false
            "
            :route="route"
            @click.native="contactUs(route.meta.openModal)"
          >
            <component
              v-if="route.meta.icon != ''"
              :class="['menu-item__icon', route.meta.icon]"
              :is="iconPath(route.meta.icon)"
            />
          </menu-item>
        </template>
      </template>
    </ul>
  </nav>
</template>

<script>
import MenuItem from "./MenuItem.vue"
import { mapGetters } from "vuex"

export default {
  components: {
    MenuItem
  },
  methods: {
    iconPath(name) {
      return require(`@/assets/svg/${name}.svg`).default
    },
    contactUs(run) {
      if (run) {
        this.$store.dispatch("openModal", {
          name: "contact-us"
        })
      }
    }
  },
  computed: {
    ...mapGetters(["permission_routes"]),
    routes() {
      return this.permission_routes || []
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/mixins.scss";
@import "@/styles/variables.scss";
.menu {
  margin-top: 24px;
  font-size: 0.88em;
  max-height: calc(100vh - 133.32px);
  overflow-y: auto;
  overflow-x: hidden;
  // @include scrollbars(0.4em, $color-secondary--dark, $color-secondary--light);
  @include scrollbars(0.4em, $color-primary--dark, $color-primary--light);
  ul {
    padding: 0 0 0 8px;
    margin: 0;

    .menu-item__icon {
      height: 21px;
      width: auto;
      top: -6px;
      position: absolute;
      fill: #fff;
      &.video {
        height: 17px;
        top: -3px;
        left: -2px;
      }
    }
  }
}
</style>
